import { render, staticRenderFns } from "./storeSet.vue?vue&type=template&id=52b5a61c&scoped=true"
import script from "./storeSet.vue?vue&type=script&lang=ts"
export * from "./storeSet.vue?vue&type=script&lang=ts"
import style0 from "./storeSet.vue?vue&type=style&index=0&id=52b5a61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b5a61c",
  null
  
)

export default component.exports